import React from 'react';
import classes from './Title.module.css';

export const Title = React.memo(({ title, isMobileOS }) => (
    <div className={`${classes.titleContainer} ${isMobileOS && classes.mobileTitle}`}>{title}</div>
));